<mat-toolbar color="--neutral-light" class="toolbar">
	@if (!breakpointSidenavState) {
		<button mat-icon-button (click)="open()">
			<lucide-angular name="menu"></lucide-angular>
		</button>
	}

	<a href="/home"
		><img
			[ngClass]="isSmall || isXSmall ? 'small-img-logo' : 'img-logo'"
			src="assets/img/visec_logo.png"
			alt="Logo ViSeC"
		/>
	</a>
	<div
		class="mat-typography user-info-container"
		[ngClass]="{ 'is-phone-portrait': drawerSize.xSmall }"
	>
		<div
			class="name-user"
			[ngClass]="{
				'no-company': !userCompany,
				'xs-text': isSmall || isXSmall,
				'center-user-name': isSmall || isXSmall
			}"
		>
			<lucide-angular name="user" class="custom-icon"></lucide-angular>
			<div class="ml-05">
				<b matTooltip="{{ currentUserInfo.nombre }}">{{
					currentUserInfo.nombre
				}}</b>
				<p matTooltip="{{ userCompany }}" class="company-name">
					{{ userCompany }}
				</p>
			</div>
		</div>
		@if (breakpointSidenavState) {
			<section>
				@if (!esOperadorSistema) {
					<button mat-icon-button [matMenuTriggerFor]="menu">
						<lucide-angular name="ellipsis-vertical"></lucide-angular>
					</button>
				}
				<mat-menu #menu="matMenu">
					@for (empresa of userCompanies | keyvalue; track empresa) {
						<button mat-menu-item (click)="seleccionarEmpresa(empresa.value)">
							<span>{{ empresa.key }} </span>
						</button>
					}
				</mat-menu>
				<button mat-icon-button (click)="logoff()" matTooltip="Cerrar sesión">
					<lucide-angular name="log-out"></lucide-angular>
				</button>
			</section>
		}
	</div>
</mat-toolbar>
